import React from 'react';
import './index.css';
import {config, sourceFlag} from "../../constants";
import axios from 'axios';
import authHeader from '../../services/auth-header';
import commonService from '../../services/common.service';


export default class TestsListItemComponent extends React.Component {

    constructor(props) {
        
        super(props);

        this.state = {
            result: {}
        }

    }

    test = (id) => {
        axios.get(config.API_URL + "tests/test/" + id, {headers: authHeader()}).then(response => {
            console.log(response.data)
            //this.setState({result:JSON.parse(response.data)})
        })
    }

    setKeepUpToDate = (id) =>{
        axios.post(config.API_URL + `tests/toggle/${id}`,null, {headers: authHeader()}).then(
          response => {
                console.log(response)
                window.location.reload(false);
            }
        );
    }


    render() {
        let data = this.props.data;

        return (

                <tr>
                    <td>{data.name}</td>
                    <td></td>
                    <td><button onClick={val => this.test(data.id)} className='config-btn config-edit-btn'>🧪</button></td>
                    <td><button className='config-btn config-edit-btn' onClick={val => this.setKeepUpToDate(data.id)}>{data.active ? '✅': '🛑' }</button></td>
                </tr>            

        );
    }
}